import { useThemeStore } from '@/store';
import {
  Button,
  Dropdown,
  Flex,
  Typography,
  theme as themeContext,
} from '@contiple/antd-ds';
import { Theme, type ThemeType } from '@contiple/antd-ds/themes';
import { useTranslation } from 'react-i18next';

const ThemeToggle = () => {
  const { token } = themeContext.useToken();

  const { t } = useTranslation();
  const { theme, setTheme } = useThemeStore();

  const menuItems = Object.values(Theme).map((s) => ({
    key: s as string,
    label: t(`theme.${s}`),
  }));

  const handleMenuClick = ({ key }: { key: string }) => {
    setTheme(key as ThemeType);
  };

  return (
    <Flex gap="8px" align="center" justify="center">
      <Typography.Text style={{ color: token.Layout?.headerColor }}>
        {t('theme.current')}:
      </Typography.Text>
      <Dropdown
        menu={{ items: menuItems, onClick: handleMenuClick }}
        placement="bottom">
        <Button>{t(`theme.${theme}`)}</Button>
      </Dropdown>
    </Flex>
  );
};

export default ThemeToggle;
